import React from 'react';
import PropTypes from 'prop-types';
import UserRolesList from '../UserRolesList';
import PermissionsList from '../PermissionsList';

import { Map } from 'immutable';

import Form from '../Form';

class CreateRoleForm extends Form {
    static fieldsValidation = {
        name: [ 'required' ]
    };
    static propTypes = {};

    static defaultProps = {
        ...Form.defaultProps,
        permissions: Map()
    };

    constructor(props, context) {
        super(props, context);
    }

    onSubmit(e, ...args) {
        e.preventDefault();
        super.onSubmit(e, ...args);
    }

    onRoleChange(grants) {
        let { data } = this.state;

        data.grants = grants;

        this.setState({ data });
    }

    renderForm() {
        return (
            <div>
                <div className="row">
                    <div className="col-4">
                        { this.getField(
                            <input
                                type="text"
                                label="Name"
                                key="name"
                                { ...this.getFieldParameters('name') }
                            />
                        ) }
                    </div>
                    <div className="col-8">
                        <PermissionsList
                            onRoleChange={ this.onRoleChange.bind(this)}
                            permissions={ this.props.permissions }
                            editing
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <button type="submit" className="btn btn-primary">
                            Add role
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default CreateRoleForm;
